export default __webpack_public_path__ + "static/content-3-mobile_2-d3e024e031a66c214d683a8e5d364413.png";